// Kleines, abhängigkeitsfreies Konfetti. Legt kurz ein Vollbild-Canvas an,
// lässt Partikel herabregnen und entfernt sich danach selbst wieder.
// Farben aus der TCG-Palette. Nutzer mit reduzierter Bewegung sehen nichts.

type Particle = {
    x: number; y: number;
    vx: number; vy: number;
    size: number;
    rot: number; vrot: number;
    color: string;
    shape: 0 | 1; // 0 = Rechteck, 1 = Kreis
};

const COLORS = ["#E8BA80", "#D4A24C", "#DA8E42", "#3FD0C9", "#FFFFFF"];

export function fireConfetti(): void {
    if (typeof window === "undefined") return;
    if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return;

    const canvas = document.createElement("canvas");
    canvas.setAttribute("aria-hidden", "true");
    canvas.style.cssText =
        "position:fixed;inset:0;width:100vw;height:100vh;pointer-events:none;z-index:2147483000";
    document.body.appendChild(canvas);

    const ctx = canvas.getContext("2d");
    if (!ctx) { canvas.remove(); return; }

    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    let W = window.innerWidth;
    let H = window.innerHeight;
    const applySize = () => {
        W = window.innerWidth;
        H = window.innerHeight;
        canvas.width = Math.floor(W * dpr);
        canvas.height = Math.floor(H * dpr);
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    };
    applySize();
    window.addEventListener("resize", applySize);

    const COUNT = 140;
    const particles: Particle[] = Array.from({ length: COUNT }, () => ({
        x: Math.random() * W,
        y: -20 - Math.random() * H * 0.4, // oberhalb des Bildschirms starten
        vx: (Math.random() - 0.5) * 1.2,
        vy: 2 + Math.random() * 3,
        size: 6 + Math.random() * 6,
        rot: Math.random() * Math.PI,
        vrot: (Math.random() - 0.5) * 0.3,
        color: COLORS[(Math.random() * COLORS.length) | 0],
        shape: Math.random() < 0.5 ? 0 : 1,
    }));

    const DURATION = 1600; // ms
    const start = performance.now();
    let raf = 0;

    const tick = (now: number) => {
        const elapsed = now - start;
        ctx.clearRect(0, 0, W, H);

        const fade = elapsed > DURATION - 400
            ? Math.max(0, (DURATION - elapsed) / 400)
            : 1;

        for (const p of particles) {
            p.x += p.vx;
            p.y += p.vy;
            p.vy += 0.03;   // leichte Schwerkraft
            p.vx *= 0.995;
            p.rot += p.vrot;

            ctx.save();
            ctx.globalAlpha = fade;
            ctx.translate(p.x, p.y);
            ctx.rotate(p.rot);
            ctx.fillStyle = p.color;
            if (p.shape === 0) {
                ctx.fillRect(-p.size / 2, -p.size / 4, p.size, p.size / 2);
            } else {
                ctx.beginPath();
                ctx.arc(0, 0, p.size / 2.4, 0, Math.PI * 2);
                ctx.fill();
            }
            ctx.restore();
        }

        if (elapsed < DURATION) {
            raf = requestAnimationFrame(tick);
        } else {
            cancelAnimationFrame(raf);
            window.removeEventListener("resize", applySize);
            canvas.remove();
        }
    };

    raf = requestAnimationFrame(tick);
}